module.exports = __webpack_public_path__ + "static/liva-convert-detail-one-71763bf8e600ac4cbccd8e69daa96e5b.png";